import React from "react";
import { useContext } from "react";
import ReactQuill from "react-quill";
import { Label } from "structure/Document";
import { BankAccountContext } from "..";

export default function Description() {
  const context = useContext(BankAccountContext);

  return (
    <>
      <Label>Descripción</Label>
      <div className="ticketCommentBox">
        <div
          className="commentBox"
          style={{
            height: "200px",
          }}
        >
          <ReactQuill
            theme="snow"
            value={context.account?.description || ""}
            onChange={(description) => context.setdescription(description)}
            preserveWhitespace
          />
        </div>
      </div>
    </>
  );
}
